import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const ArrowRight: FC<Props> = ({ className }) => (
  <svg
    fill="none"
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.43 5.92999L20.5 12L14.43 18.07M3.5 12H20.33"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowRight;
